import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg, num, rupee } from "@/lib/api";

export const CoveredCallIdeas = ({ connected }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setD((await api.get("/covered-call/ideas")).data); } catch (e) { setD({ error: errMsg(e), holdings: [] }); } finally { setBusy(false); }
  };
  return (
    <div className="panel col-span-12" data-testid="panel-covered-call-ideas">
      <div className="flex items-center justify-between border-b border-slate-800 px-4 py-2.5">
        <span className="eyebrow">Covered-call ideas from your Dhan holdings · suggestions only</span>
        <Button data-testid="button-load-cc-ideas" size="sm" variant="ghost" disabled={!connected || busy} onClick={load} className="h-7 gap-1 text-xs text-slate-400">
          <RefreshCw size={12} className={busy ? "animate-spin" : ""} /> {d ? "Refresh" : "Load holdings"}
        </Button>
      </div>
      {!connected ? <p className="p-4 text-sm text-slate-500">Connect Dhan to read your holdings.</p> : !d ? (
        <p className="p-4 text-sm text-slate-500" data-testid="cc-ideas-idle">Reads your holdings (read-only) and suggests an OTM call ({`≈`} set OTM %) to sell against each one. Nothing is ever placed.</p>
      ) : (
        <div className="overflow-x-auto">
          {d.error && <p className="px-4 pt-3 text-xs text-amber-400" data-testid="cc-ideas-error">{d.error}</p>}
          <table className="dense num w-full" data-testid="table-cc-ideas">
            <thead><tr><th>Holding</th><th>Qty</th><th>LTP</th><th>Suggested call</th><th>Lots</th><th>Est. premium</th><th>Est. income</th><th className="!text-left">Note</th></tr></thead>
            <tbody>
              {d.holdings.length === 0 && <tr><td colSpan={8} className="!py-6 !text-center text-slate-500">No holdings found.</td></tr>}
              {d.holdings.map((h, i) => (
                <tr key={i} data-testid={`cc-idea-${h.symbol}`}>
                  <td className="text-slate-200">{h.symbol}</td><td>{h.qty}</td><td>{num(h.ltp)}</td>
                  <td className={h.eligible === false ? "text-slate-500" : "text-indigo-300"}>{h.instrument || "—"}</td>
                  <td>{h.lots ?? "—"}</td><td>{num(h.est_premium)}</td>
                  <td className="up">{h.est_income != null ? rupee(h.est_income) : h.est_income_per_share != null ? `${num(h.est_income_per_share)}/sh` : "—"}</td>
                  <td className="max-w-[340px] !text-left text-[11px] text-slate-500">{h.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="px-4 py-2 text-[11px] text-slate-600">Premiums are Black-Scholes estimates at {d.iv}% IV (stocks use 1.6× that), not live quotes. Check the real option chain in Dhan before you sell.</p>
        </div>
      )}
    </div>
  );
};
